import { ApiResponse, CreateOrderRequest, Order, OrderResponseData } from '@/types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const tradeApi = {
  /**
   * Place a buy or sell order
   */
  placeOrder: async (payload: CreateOrderRequest): Promise<ApiResponse<OrderResponseData>> => {
    const { data } = await axiosClient.post<ApiResponse<OrderResponseData>>(
      API_ENDPOINTS.TRADE.ORDER,
      payload
    );
    return data;
  },

  /**
   * List open orders
   */
  getOrders: async (): Promise<ApiResponse<Order[]>> => {
    const { data } = await axiosClient.get<ApiResponse<Order[]>>(API_ENDPOINTS.TRADE.ORDERS);
    return data;
  },

  /**
   * Get specific order status
   */
  getOrderStatus: async (orderId: string): Promise<ApiResponse<Order>> => {
    const { data } = await axiosClient.get<ApiResponse<Order>>(
      API_ENDPOINTS.TRADE.ORDER_BY_ID(orderId)
    );
    return data;
  },

  /**
   * Cancel a specific order
   */
  cancelOrder: async (
    orderId: string
  ): Promise<ApiResponse<{ success: boolean; message: string }>> => {
    const { data } = await axiosClient.delete<ApiResponse<{ success: boolean; message: string }>>(
      API_ENDPOINTS.TRADE.ORDER_BY_ID(orderId)
    );
    return data;
  },

  /**
   * Cancel all open orders
   */
  cancelAllOrders: async (): Promise<ApiResponse<{ success: boolean; message: string }>> => {
    const { data } = await axiosClient.delete<ApiResponse<{ success: boolean; message: string }>>(
      API_ENDPOINTS.TRADE.CANCEL_ALL
    );
    return data;
  },
};
